module.exports = __webpack_public_path__ + "static/media/s3.3e8920d6.png";